import React from 'react';
import styled from 'styled-components';
import { Button, Divider, Space } from 'tdesign-react';
import qs from 'qs';
import { useNavigate } from 'react-router-dom';
import SvgIcon from '@/components/SvgIcon';
import PermWrapper from '@/components/PermWrapper';
import icon1 from './icon1.png';
import icon2 from './icon2.png';

export default function Card({ detail }) {
  const navigate = useNavigate();
  const { flowType, name, note, createBy } = detail;

  const isK8s = flowType === 1;

  return (
    <Root>
      <Tag $isK8s={isK8s}>{isK8s ? 'K8s' : '主机'}</Tag>
      <Top>
        <Avatar src={flowType === 1 ? icon2 : icon1} />
        <Right>
          <Title>{name}</Title>
          <SubTitle>{note}</SubTitle>
          <SubTitle>创建人：{createBy}</SubTitle>
        </Right>
      </Top>
      <Footer size={0} separator={<Divider layout='vertical' />}>
        <PermWrapper resource='pulsar:exec:flow:record'>
          <Button
            theme='default'
            variant='text'
            icon={<SvgIcon type='document-duplicate' />}
            onClick={() => {
              setTimeout(() => {
                // 略等动效
                navigate('/maintenance/executive/record?stencilType=2');
              }, 100);
            }}
          >
            执行记录
          </Button>
        </PermWrapper>
        <PermWrapper resource='pulsar:exec:flow:detail'>
          <Button
            theme='default'
            variant='text'
            icon={<SvgIcon type='document-search' />}
            onClick={() =>
              setTimeout(() => {
                // 略等动效
                navigate(
                  `/maintenance/template/flow/detail${qs.stringify(detail, {
                    addQueryPrefix: true,
                  })}`,
                );
              }, 100)
            }
          >
            查看详情
          </Button>
        </PermWrapper>
        <PermWrapper resource='pulsar:exec:flow:exec'>
          <Button
            variant='text'
            theme='primary'
            icon={<SvgIcon type='cursor-click' />}
            onClick={() => {
              setTimeout(() => {
                // 略等动效
                navigate(
                  `/maintenance/executive/flow/detail?flowId=${detail.id}&flowType=${detail.flowType}`,
                );
              }, 100);
            }}
          >
            执行
          </Button>
        </PermWrapper>
      </Footer>
    </Root>
  );
}

const Root = styled.div`
  width: 359px;
  border-radius: 6px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px 20px 14px;
  position: relative;
  overflow: hidden;
`;

const Top = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 28px;
`;

const Avatar = styled.img`
  width: 76px;
  height: 76px;
  border-radius: 100%;
  overflow: hidden;
  margin-right: 18px;
`;

const Right = styled.div`
  flex: 1;
  min-width: 0;
`;

const Title = styled.div`
  font-size: 15px;
  color: var(--td-text-color-primary);
  font-weight: bold;
  padding-bottom: 4px;
`;

const SubTitle = styled.div`
  font-size: 13px;
  color: var(--td-text-color-secondary);
  margin-top: 2px;
`;

const Footer = styled(Space)`
  .t-button {
    width: 90px;
    padding: 0;
    svg {
      margin-right: 4px;
    }
  }
`;

const Tag = styled.div`
  background-image: ${(props) =>
    props.$isK8s
      ? 'linear-gradient(228deg, #1A9EFF 0%, rgba(41, 204, 203, 0.3) 100%)'
      : 'linear-gradient(228deg, #29cca3 0%, rgba(41, 204, 203, 0.4) 100%)'};
  width: 50px;
  height: 22px;
  border-bottom-left-radius: 6px;
  position: absolute;
  z-index: 1;
  right: 0;
  top: 0;
  color: white;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
`;
